import React from "react";
import useSWR from "swr";
import Scroll from "react-scroll";
import { Candidat } from "./Candidat";
import { Tabs } from "./Tabs";
import { Map } from "./Map";
import { apiPath, fetcher } from "./constants";

const Element = Scroll.Element;
const scroller = Scroll.scroller;

const stJerome = "75017";
const boucherville = "58033";
const perce = "2005";
const matapedia = "6045"
const quebec = "23027";
export function App({ city = stJerome }) {
  const [scrollTo, setScrollTo] = React.useState();
  const [selected, setSelected] = React.useState(0);
  const { data, error } = useSWR(`${apiPath}api/courses/${city}`, fetcher);

  function locationHashChanged(e) {
    const anchor = location.hash.replace("#", "").split("-");
    switch (anchor[0]) {
      case "resultats":
        setScrollTo({ tab: "1", id: anchor[0] + "-" + anchor[1] });
        break;
      case "candidats":
        setScrollTo({ tab: "0", id: anchor[0] + "-" + anchor[1] });
        break;
      default:
      case "ouvoter":
        setScrollTo({ tab: "2", id: anchor[0] + "-" + anchor[1] });
        break;
    }
  }

  React.useEffect(() => {
    if (scrollTo?.tab) {
      setSelected(parseInt(scrollTo.tab) || 0);
      scroller.scrollTo(scrollTo.id);
      setTimeout(() => {
        setScrollTo(null);
      }, 1000);
    }
  }, [scrollTo, selected]);

  window.onhashchange = locationHashChanged;

  if (error) return <div>Erreur</div>;
  if (!data) return <div>Chargement...</div>;
  return (
    <div>
      {data.coordinates && <Map city={city} data={data.coordinates} />}
      <Tabs
        setSelected={setSelected}
        selected={selected}
        tabs={[
          { title: "Candidats" },
          { title: "Résultats" },
          { title: "Où voter" },
        ]}
      >
        <CandidatsSection {...data} />
        <ResultatsSection {...data.results} />
        <OuVoter {...data.offices} />
      </Tabs>
    </div>
  );
}

function ResultatsSection({ electedMayor, electedCityCounsellors }) {
  return (
    <>
      <h2>Résultats</h2>
      <section className="tle_candidats_section">
        <h3>Mairie</h3>
        <section className="tle_candidats_section_candidats">
          {electedMayor.elected ? <Candidat {...electedMayor.elected} /> : <p>Aucun élu pour le moment</p>}
        </section>
      </section>

      <section className="tle_candidats_section">
        <h3>Conseil municipal</h3>
        {Object.entries(electedCityCounsellors).map(([key, { elected }]) => (
          <Element key={key} name={`resultats-district${key}`}>
            <section className="tle_candidats_subsection">
              <h4>District {key}</h4>
              {elected ? <Candidat {...elected} /> : <p>Aucun élu pour le moment</p>}

            </section>
          </Element>
        ))}
      </section>
    </>
  )
}


function OuVoter({ ...offices }) {
  return (
    <>
      <h2>Où voter</h2>

      {!offices ? (
        <p>Aucun bureau de vote n'est disponible.</p>
      ) : (
        <>
          {Object.entries(offices).map(([key, office]) => (
            <Element key={`office-${key}`} name={`ouvoter-district${key}`}>
              <section className="tle_ouvoter_section">
                <h3>District {key}</h3>
                {office?.electionDay && office?.anticipation ? (
                  <ShowLocations data={office} />
                ) : (
                  Object.entries(office).map(([subkey, suboffice]) => (
                    <section
                      className="tle_ouvoter_subsection"
                      key={`suboffice-${subkey}`}
                      id={`district-${key}-bureau-${subkey}`}
                    >
                      <h4>Bureau {subkey}</h4>
                      <ShowLocations data={suboffice} />
                    </section>
                  ))
                )}
              </section>
            </Element>
          ))}
        </>
      )}
    </>
  );
}

function CandidatsSection({ runningForCityCounsellor, runningForMayor }) {
  return (
    <>
      <h2>Candidats</h2>
      <section className="tle_candidats_section">
        <h3>Mairie</h3>
        <section className="tle_candidats_section_candidats">
          {runningForMayor.map((candidat) => (
            <Candidat hidePoste key={candidat._id} {...candidat} />
          ))}
        </section>
      </section>

      <section className="tle_candidats_section">
        <h3>Conseil municipal</h3>
        {Object.entries(runningForCityCounsellor).map(([key, candidats]) => (
          <Element key={key} name={`candidats-district${key}`}>
            <section className="tle_candidats_subsection">
              <h4>District {key}</h4>
              <section className="tle_candidats_section_candidats">
                {candidats.map((candidat) => (
                  <Candidat hidePoste key={candidat._id} {...candidat} />
                ))}
              </section>
            </section>
          </Element>
        ))}
      </section>
    </>
  );
}

const ShowLocations = ({ data }) => {
  const addressMarkup = ({
    address,
    city = "",
    latitude,
    locationName,
    longitude,
    postalCode = "",
  }) => (
    <address>
      {locationName && (
        <strong>
          {locationName}
          <br />
        </strong>
      )}
      {address && (
        <>
          {address},
          <br />
        </>
      )}
      {city && (
        <>
          {city}
          <br />
        </>
      )}
      {postalCode && (
        <>
          {postalCode}
          <br />
        </>
      )}
      {latitude && longitude && (
        <>
          <a
            href={`http://maps.google.com/maps?q=${address}+${city}+${postalCode}+${locationName}&ll=${latitude},${longitude}&hl=fr&z=15&daddr=${address}+${postalCode}`}
            /*   href={`https://www.google.com/maps/place/${locationName}/@${latitude},${longitude},14z`} */
            target="_blank"
          >
            Voir sur Google Maps
          </a>
          <br />
        </>
      )}
    </address>
  );
  const sectionNumbers =
    data.electionDay.sections.length > 1
      ? data.electionDay.sections.reduce((acc, curr, index) => {
        return index === data.electionDay.sections.length - 2
          ? (acc += `${curr} ou `)
          : (acc += `${curr}, `);
      }, "")
      : data.electionDay.sections.join(", ");
  return (
    <>
      {data.electionDay?.sections?.length ? (
        <p>
          Si votre section de vote est {sectionNumbers} votre vote est attendu
          au lieu suivant:
        </p>
      ) : null}
      <table>
        <thead>
          <tr>
            <th>Le jour du vote (7 novembre)</th>
            <th>Par anticipation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{addressMarkup(data.electionDay)}</td>
            <td>{addressMarkup(data.anticipation)}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
